import { Text, Button, Grid, Box, useTheme } from '@simplywallst/ui-core';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

interface Props {
  holding: string;
  onRemove: () => void;
}

export const HoldingTag = ({ holding, onRemove }: Props) => {
  const theme = useTheme();
  return (
    <Box
      as="span"
      display="inline-block"
      marginRight="x0_5"
      marginBottom="x0_5"
    >
      <Grid
        data-cy-id="holding-tag"
        templateColumns="max-content 1fr"
        alignItems="center"
        borderRadius="x0_5"
        paddingY="x0_5"
        paddingX="x1_5"
        paddingRight="x0"
        style={{
          backgroundColor: theme.color.whiteRGBA(0.1),
        }}
      >
        <Text typography="xSmall">{holding}</Text>
        <Button onClick={onRemove} aria-label="remove holding">
          <CrossSolid />
        </Button>
      </Grid>
    </Box>
  );
};
